<template>
	<div id='ae' class='' v-loading='loading'>
		<div class='gPageBorder'>
			<div
				style='width:140px;height:140px;margin:24px 24px 24px 24px;display:inline-block;float:left;overflow:hidden;'>
				<div :style="avtStyle">
					<!-- <img style='width:100%;' :src="imgFullUrl(config? config.data.appBigIcon : '')"> -->
				</div>
			</div>
			<div style='display:inline-block;width:calc(100% - 188px);height:100%;margin-bottom:0px;:'>
				<div style='height:64px;'>
					<button class='dt-word-appmain'
						style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{ config ?
							config.data.appName : ''}}</button>
				</div>
				<div style='height:60px;'>
					<table class='dt-app-app'>
						<tr>
							<td>
								<label class='dt-word-apptt'>{{ $t('psp_app_id') }}：</label>
								<label class='dt-word-appmain'>{{ app_detail ? app_detail.appId : '' }}
								</label>
							</td>
							<td>
								<label class='dt-word-apptt'>{{ $t('app_appName') }}：</label>
								<label class='dt-word-appmain'>{{ app_detail ? app_detail.fileName : '' }}</label>
							</td>
							<td>
								<label class='dt-word-apptt'>{{ $t('app_sysType') }}：</label>
								<label class='dt-word-appmain' v-if="app_detail.sysType == '0'">RTOS</label>
								<label class='dt-word-appmain' v-if="app_detail.sysType == '1'">Linux</label>
								<label class='dt-word-appmain' v-if="app_detail.sysType == '2'">LiteOS</label>
							</td>
							<td>
								<label class='dt-word-apptt'>{{ $t('psp_app_version') }}：</label>
								<label class='dt-word-appmain'>{{ app_detail ? app_detail.appVersion : '' }}</label>
							</td>


						</tr>
						<tr>
							<td>
								<label class='dt-word-apptt'>{{ $t('app_introl') }}：</label>
								<label class='dt-word-appmain'>{{ app_detail ? app_detail.memo : '' }}</label>
							</td>
							<td>
								<label class='dt-word-apptt'>{{ $t('app_ulTime') }}：</label>
								<label class='dt-word-appmain'>{{ app_detail ? app_detail.createTime : '' }}</label>
							</td>
							<td>
							</td>
							<td>
							</td>
						</tr>
					</table>
				</div>
				<div style='min-height:60px;display:flex;display:-webkit-flex;'>
				</div>
			</div>
		</div>


		<div class='gPageBorder gTopMg' style=''>

			<p class='gCtColor gPTitle' style=''>{{ $t('app_appUpList') }} </p>
			<!-- <el-button :disabled="tableData? tableData.length == 0 : false"  @click='uploadNew' type='primary' style='margin: 24px 0 24px 24px' class=''>{{$t('app_ulNew')}}</el-button> -->
			<!-- <div class="" style='margin: 24px 0 24px 24px;height: 1px;'>
				
			</div> -->
			<el-row>
				<el-col :span="8" class=''>
					<div class='gCtrl'>
					</div>
				</el-col>
				<el-col :span="4">
					<div class='gCtrl'>

					</div>
				</el-col>

				<el-col :span="4">
					<div class='gCtrl'>
					</div>
				</el-col>

				<el-col :span="4">
					<div class='gCtrl'>
					</div>
				</el-col>


				<el-col :span="4">
					<div class='gSideCtrl'>
						<el-input :placeholder="$t('app_terminal')" v-model='terminalNo'
							@keyup.enter.native='getAppList' icon="search" :on-icon-click="getAppList"></el-input>
					</div>
				</el-col>

			</el-row>
			<el-table :data="tableData" border style="width: 100%;margin-top: 10px;">
				<el-table-column header-align='center' align='center' prop="terminalNo" width=''
					:label="$t('app_terminal')">
				</el-table-column>
				<el-table-column header-align='center' align='center' prop="status" :label="$t('app_status')"
					width="">
					<template slot-scope='scope'>
						<span v-if="scope.row.status == 1" >{{ $t('app_success') }}</span>
						<span v-if="scope.row.status == 2" >{{ $t('mao_global.tip.fail') }}</span>
					</template>
				</el-table-column>
				<el-table-column header-align='center' align='center' :formatter="dateFormat" prop="updateTime"
					:label="$t('app_ulTime')">
				</el-table-column>

			</el-table>
			<div class="gPgDiv" style=''>
				<el-pagination class='gPg' @current-change="pageSelect" @size-change="pageSized" :current-page="index"
					:page-sizes='$gRows' :page-size="row" layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</div>

	</div>
</template>

<style>
.dt-word-appmain {
	color: rgb(72, 87, 106)
}

.dt-word-apptt {
	color: #99A9BF;
}

pre {
	white-space: pre-wrap;
	word-wrap: break-word;
	white-space: -moz-pre-wrap;
	white-space: -pre-wrap;
	white-space: -o-pre-wrap;
	word-break: break-all;
}

.dt-app-app {
	width: 100%;
	height: 100%;
}

.dt-app-app td {
	width: 25%;
}

/* upload */
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.capture {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	width: 120px;
	display: inline-block;
}

.capture div {
	float: left;
}

.avatar-uploader .el-upload:hover {
	border-color: #20a0ff;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 128px;
	height: 128px;
	line-height: 128px;
	text-align: center;
}

/* upload */
.sm-avatar-uploader-icon {
	font-size: 36px;
	color: #8c939d;
	width: 72px;
	height: 72px;
	line-height: 72px;
	text-align: center;
}

.sm-avatar {
	width: 64px;
	height: 64px;
	display: block;
}
</style>

<script>
import mm from 'moment'
import df from '../../assets/df.png'
import tyc from '@/components/global/tyc'
export default {
	data() {
		return {
			total: 0,
			queryKey: '',
			terminalNo: "",
			sNum: 0,
			page: 1,
			tableData1: [],
			tableData: [],
			list: [],
			pushedList: false,
			tqobj: '',
			dobj: '',
			vSt: '',
			config: '',
			captures: [],
			loading: 0,
			iconUrl: '',
			app_detail: {}
		}
	},
	components: {
		tyc
	},
	computed: {
		avtStyle() {
			//this.config.data.appBigIcon
			var url = this.iconUrl ? this.imgFullUrl(this.iconUrl) : require('../../assets/df.png')

			return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' +
				url + ')'
		},
	},
	methods: {
		dateFormat(row, column) {
			var date = row[column.property];
			if (date === undefined) {
				return "";
			}
			return mm(date).format("YYYY-MM-DD HH:mm:ss");
		},
		pageSelect(index) {
			this.$setWPage("appPage", index);
			this.getAppList();
		},
		pageSized(val) {
			this.$gRow = val;
			this.getAppList();
		},


		getAppList() {
			this.loading = 1
			this.$pspUpdateList({
				page: this.$getWPage("appPage"),
				rows: this.$gRow,
				fileId: this.app_detail.id,
				terminalNo: this.terminalNo
			}, (res) => {
				this.loading = 0
				if (res.status === 200) {
					this.total = res.total;
					this.tableData = res.data
				} else {
					this.$message.error(res.message)
				}
			}, () => {
				// error
				this.loading = 0
			})

		},

	},
	created() {
		this.config = this.$getWObj().pspDetail
		this.app_detail = JSON.parse(JSON.stringify(this.config.data))
		console.log(this.app_detail)
		this.getAppList()



	}
}
</script>


// WEBPACK FOOTER //
// pspDetail.vue?00c3086e